import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { REACT_APP__APP_NAME } from "@smp/utils";
import { useTitle } from "react-use";

type IPageTitleId =
  | "/"
  | "/academy"
  | "/accounts"
  | "/affiliate_program"
  | "/assistant"
  | "/auth/recovery"
  | "/auth/signin"
  | "/auth/signup"
  | "/billing"
  | "/billing/payments"
  | "/help"
  | "/posts"
  | "/post"
  | "/promo"
  | "/shared/post"
  | "/reports"
  | "/repost"
  | "/sc"
  | "/settings"
  | "/streams"
  | "/teams"
  | "/templates"
  | "/projects";

export const useWindowTitle = (titleId: IPageTitleId, titleParam?: string) => {
  const { i18n } = useLingui();

  const titles: Record<IPageTitleId, string> = {
    "/": i18n._(t`Automated posting system`),
    "/academy": i18n._(t`Academy`),
    "/accounts": i18n._(t`Accounts`),
    "/affiliate_program": i18n._(t`Affiliate program`),
    "/assistant": i18n._(t`AI assistant`),
    "/auth/recovery": i18n._(t`Reset Password`),
    "/auth/signin": i18n._(t`Sign in`),
    "/auth/signup": i18n._(t`Sign up`),
    "/billing": i18n._(t`Billing`),
    "/billing/payments": i18n._(t`Payments`),
    "/help": i18n._(t`Help`),
    "/post": i18n._(t`Post`),
    "/posts": i18n._(t`Posts`),
    "/promo": i18n._(t`Promo pages`),
    "/shared/post": i18n._(t`Post preview: ${titleParam}`),
    "/reports": i18n._(t`Analytics`),
    "/repost": i18n._(t`Repost`),
    "/sc": i18n._(t`Story Constructor`),
    "/settings": i18n._(t`Settings`),
    "/streams": i18n._(t`Re-stream`),
    "/teams": i18n._(t`Teams`),
    "/templates": i18n._(t`templates.viewport.title_Templates`),
    "/projects": i18n._(t`Projects`),
  };

  const title = titles[titleId];

  useTitle(`${REACT_APP__APP_NAME} | ${title}`);
};
